import { render, staticRenderFns } from "./BaseConfigWidget.vue?vue&type=template&id=4c14a3b6&"
import script from "./BaseConfigWidget.vue?vue&type=script&lang=ts&"
export * from "./BaseConfigWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports